var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactusPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.738,
    height: 21.159,
    viewBox: "0 0 16.738 21.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1711",
    "data-name": "Group 1711",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M142.076,37.276a5.315,5.315,0,0,0-1.62-2.144c-.777-.6-1.888-1.286-2.9-.842a1.677,1.677,0,0,0-.683.562,2.232,2.232,0,0,0-.294.558c-.016.044-.677,2.137-.922,3.156a1.375,1.375,0,0,0,.4,1.525,2.531,2.531,0,0,0,.5.324c.469.238.957.438,1.446.635l.2.082.575.218-.211.6a21.114,21.114,0,0,1-5.34,8.256l-.4.426-.5-.479a11.292,11.292,0,0,0-1.185-1.169A1.51,1.51,0,0,0,129,48.938a24.413,24.413,0,0,0-2.607,2.213,1.667,1.667,0,0,0,.045,2.653,4.894,4.894,0,0,0,2.751,1.436,6.4,6.4,0,0,0,4.14-.92,18.218,18.218,0,0,0,2.845-2.039l1.2-1.156a20.223,20.223,0,0,0,4.569-8.214A8.677,8.677,0,0,0,142.076,37.276Z",
    transform: "translate(-125.758 -34.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M350.9,41.43c.682-1.973,1.29-4.047,1.806-6.116-.042-.035-.085-.07-.128-.1a3.452,3.452,0,0,0-2.56-.948,1.832,1.832,0,0,0-1.364,1.36c-.31,1-.631,2-.877,3.023a1.441,1.441,0,0,0,.9,1.849c.534.271,1.094.494,1.651.718Z",
    transform: "translate(-337.882 -34.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M132.83,360.817c-.7.715-1.437,1.414-2.2,2.1a26.866,26.866,0,0,1-2.633,2.143,4.684,4.684,0,0,1-1.554-1.081,1.666,1.666,0,0,1-.045-2.652A24.4,24.4,0,0,1,129,359.118a1.509,1.509,0,0,1,2.139.052,11.358,11.358,0,0,1,1.185,1.168Z",
    transform: "translate(-125.759 -344.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ADEcVW_1_",
    transform: "translate(0.027 2.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1448",
    "data-name": "Group 1448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M142.517,86.421A18.846,18.846,0,0,1,133.9,97.831a6.4,6.4,0,0,1-4.14.92,4.892,4.892,0,0,1-2.751-1.436,2.319,2.319,0,0,1-.654-1.11l.06.065a4.893,4.893,0,0,0,2.751,1.436,6.4,6.4,0,0,0,4.14-.92,18.846,18.846,0,0,0,8.614-11.409,8.676,8.676,0,0,0,.132-5.634l-.029-.067a5.422,5.422,0,0,1,.623,1.112A8.676,8.676,0,0,1,142.517,86.421Z",
    transform: "translate(-126.358 -79.675)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M129.169,454.487a4.892,4.892,0,0,1-2.751-1.435l-.06-.065v.006c0,.017.007.034.011.05a1.752,1.752,0,0,0,.072.217,2.115,2.115,0,0,0,.214.4,3.254,3.254,0,0,0,.275.349,4.417,4.417,0,0,0,.332.331,4.7,4.7,0,0,0,.678.51,4.778,4.778,0,0,0,.5.267c.034.016.067.031.1.046l.029.013c.308-.216.6-.432.877-.65C129.352,454.517,129.26,454.5,129.169,454.487Z",
    transform: "translate(-126.331 -434.441)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactusPhone);
export default __webpack_public_path__ + "static/media/contactus-phone.15db237d8494b7d5e6ca9ec65e6bf312.svg";
export { ForwardRef as ReactComponent };